import React, { useState } from 'react';
import { Link } from '@reach/router';
import Cookies from 'universal-cookie';
import { DOMAIN } from '../../endpoints.config';
import CookieSettingsPopup from './CookieSettingsPopup';

const CookieBanner = () => {
  const [toggleCookieSettings, setToggleCookieSettings] = useState<boolean>(false);

  const acceptSiteCookies = () => {
    const cookies = new Cookies();
    const date = new Date();
    date.setMonth(date.getMonth() + 1);

    cookies.set('cookie_settings', "all_cookies", {
      expires: date,
      domain: DOMAIN,
      sameSite: "none",
      secure: true
    }); 

    window.location.reload();
  };

  const rejectSiteCookies = () => {
    const cookies = new Cookies();
    const date = new Date();
    date.setMonth(date.getMonth() + 1);

    cookies.set('cookie_settings', "functional_and_marketing", {
      expires: date,
      domain: DOMAIN,
      sameSite: "none",
      secure: true
    });

    window.location.reload();
  };


  return (
    <>
      {!toggleCookieSettings &&
        <div className="CookieBanner">
          <div className="CookieBannerContent">
            <div className="InfoTxt">
              <p>
                We use cookies to give you the best online experience. By using our
                website you agree to our use of cookies in accordance with our cookie
                policy. <a href="https://getset4education.co.uk/info/cookie-policy" target="_blank" rel="noreferrer">Learn more here</a>
              </p>
            </div>
            <button className="Btn AcceptBtn" onClick={acceptSiteCookies}>
              Accept All
            </button>
            <button className="Btn RejectBtn" onClick={rejectSiteCookies}>
              Reject All Non-Essential
            </button>
            <button className="Btn SettingsBtn" onClick={() => setToggleCookieSettings(true)}>
              Cookie settings
            </button>        
          </div>    
        </div>      
      }

      {toggleCookieSettings &&
        <CookieSettingsPopup 
          toggleCookieSettings={toggleCookieSettings}
          setToggleCookieSettings={setToggleCookieSettings}
        />
      }
    </>
  );
};

export default CookieBanner;
